import {RotatingLines} from 'react-loader-spinner';
import PropTypes from 'prop-types';

const Spinner = ({width, strokeColor}) => {
  return (
    <div className='flex justify-center items-center'>
      <RotatingLines
        strokeColor='white'
        strokeWidth='5'
        animationDuration='0.75'
        visible={true}
        width={width}
      />
    </div>
  );
};
// Types for the width
Spinner.prototype = {
  width: PropTypes.string,
  strokeColor: PropTypes.strokeColor,
};
export default Spinner;
